import React from 'react';

const PaymentPage: React.FC = () => {
  return (
    <div className="min-h-screen p-6" style={{ background: 'var(--bg-secondary)' }}>
      <div className="max-w-4xl mx-auto">
        <div className="rounded-lg shadow-md p-8" style={{ background: 'var(--surface-primary)' }}>
          <h1 className="text-3xl font-bold mb-6" style={{ color: 'var(--text-primary)' }}>
            Purchase Tokens
          </h1>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">
                Basic Plan
              </h3>
              <p className="text-2xl font-bold text-blue-600 mb-4">$9.99</p>
              <ul className="text-blue-700 mb-6 space-y-2">
                <li>• 10 Analysis Tokens</li>
                <li>• Basic Feedback</li>
                <li>• Email Support</li>
              </ul>
              <button className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                Select Plan
              </button>
            </div>
            
            <div className="bg-green-50 p-6 rounded-lg border border-green-200">
              <h3 className="text-lg font-semibold text-green-900 mb-2">
                Pro Plan
              </h3>
              <p className="text-2xl font-bold text-green-600 mb-4">$19.99</p>
              <ul className="text-green-700 mb-6 space-y-2">
                <li>• 25 Analysis Tokens</li>
                <li>• Advanced Feedback</li>
                <li>• Priority Support</li>
              </ul>
              <button className="w-full bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
                Select Plan
              </button>
            </div>
            
            <div className="bg-purple-50 p-6 rounded-lg border border-purple-200">
              <h3 className="text-lg font-semibold text-purple-900 mb-2">
                Premium Plan
              </h3>
              <p className="text-2xl font-bold text-purple-600 mb-4">$39.99</p>
              <ul className="text-purple-700 mb-6 space-y-2">
                <li>• Unlimited Tokens</li>
                <li>• Premium Feedback</li>
                <li>• Live Chat Support</li>
              </ul>
              <button className="w-full bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700">
                Select Plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage; 